// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"1803330a","787":"d4ca66a9"}[chunkId] + ".chunk.js";
};